import React from 'react'
import { IConflictTour } from 'utils/weeklyTypes'
import styled from 'styled-components'
import { COLORS } from 'static/constants'
import { Tooltip } from 'components/atoms/Tooltip'

interface IProps {
  conflictTour: IConflictTour
  small?: boolean
}

const REQUEST_STATUS_LABELS = {
  agent_pre_requested: '他へ打診中',
  agent_official_requested: '他へ正式依頼済',
  guide_declined: '他で打診拒否',
  agent_pre_canceled: '他で打診取消',
} as const

export const ConflictTourLink = ({ conflictTour, small }: IProps) => {
  const { tour, requestStatus } = conflictTour
  const tourLabel = `${tour.post.short_name || tour.post.name} ${tour.start_time}`
  const statusLabel = REQUEST_STATUS_LABELS[requestStatus]
  const currentParams = new URLSearchParams(window.location.search)
  currentParams.set('start', tour.day)
  currentParams.set('tour_id', tour.id.toString())

  const tourUrl = `/agent/tours/weekly?${currentParams.toString()}`

  return (
    <Wrapper small={small}>
      {small ? (
        <Tooltip content={tourLabel} position="bottom">
          <a href={tourUrl} target="_blank">
            {statusLabel}
          </a>
        </Tooltip>
      ) : (
        <a href={tourUrl} target="_blank">
          {statusLabel}: {tourLabel}
        </a>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.span`
  width: fit-content;
  flex: none;
  padding: 2px 8px;

  font-size: ${props => (props.small ? '10px' : '12px')};
  font-weight: 700;
  line-height: 1.6rem;

  border-radius: 16px;
  background-color: ${COLORS.dangerBG};
  border: 1px solid ${COLORS.dangerBorder};

  :hover {
    opacity: 0.8;
  }

  a {
    color: ${COLORS.danger};
  }
`
